export default __webpack_public_path__ + "6e72c2874e93435b040fd3bb8c681ec7.png";